import { Controller } from "@hotwired/stimulus";

// Sommaire des pages légales, construit depuis les titres du document.
//
// Le corps de chaque document reste du HTML rédigé à la main : plutôt que
// d'y injecter des ancres à la main, on les dérive des <h2> au chargement.
export default class extends Controller {
  static targets = ["content", "list", "panel"];

  connect() {
    const headings = Array.from(this.contentTarget.querySelectorAll("h2"));
    if (headings.length < 2) return;

    headings.forEach((heading, index) => {
      if (!heading.id) heading.id = `legal-section-${index + 1}`;
      heading.classList.add("scroll-mt-24");

      const item = document.createElement("li");
      const link = document.createElement("a");
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent.trim();
      link.className =
        "block rounded-[10px] px-3 py-2 text-sm leading-[1.4] text-[#475569] transition-colors hover:bg-[#EEF8EA] hover:text-[#2D6E22]";
      item.appendChild(link);
      this.listTarget.appendChild(item);
    });

    this.panelTarget.classList.remove("hidden");
  }
}
